module.exports = __webpack_public_path__ + "img/Magnuss52.7200800c.jpg";